/**
 * Created by quikr on 7/18/16.
 */
//Decide which configureStore to use based on production or dev
/* eslint-disable no-console*/
console.log(process.env.REQ_URL);
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./configureStore.prod');

}

else {
  module.exports = require('./configureStore.dev');
}



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.js
 **/